import { useFeature } from '~/modules/root/hook/use-feature';

interface BookableSessionShape {
    IsActive?: boolean | null;
    MeetingType?: string | null;
}

/**
 * A professional's "Book a Meeting" row is only bookable when their linked
 * Client Director session is active and one-on-one — the same rule the project
 * detail page uses.
 */
const isBookableSession = (session?: BookableSessionShape | null): boolean =>
    Boolean(session?.IsActive && session.MeetingType === 'one-on-one');

/**
 * Whether the professional detail page may offer direct "Book a Meeting":
 * true only when the `book_meeting_open_access` feature flag is on AND the
 * linked Client Director session is bookable. With the flag off the page keeps
 * its enquiry CTAs while the booking row drops out, and because the accordion
 * and `getOverviewSectionNumbers` both derive from this hook the "(0N)"
 * section numbering stays sequential. Mirrors `useProjectBookMeeting`'s
 * `canBookDirect` on the project detail page.
 */
export const useCanBookDirectMeeting = (
    session?: BookableSessionShape | null,
): boolean =>
    useFeature('book_meeting_open_access') && isBookableSession(session);
